<div>
    <ul class="nav nav-pills" style="border-bottom: 1px solid lightgrey;">
        <li [ngClass]="{'active-tab':selectedTab=='scheduledAppointments'}" style="padding: 7px 15px;"
            (click)="updateSelectedTab('Scheduled Appointments')">
            <span style="cursor: pointer;">Scheduled Appointments</span>
        </li>
        <li ng-if="true" [ngClass]="{'active-tab':selectedTab=='customNotifications'}" style="padding: 7px 15px;"
            (click)="updateSelectedTab('Custom Notifications')"><span style="cursor: pointer;">Custom
                Notifications</span></li>
    </ul>
</div>

<div *ngIf="showCustomNotificationTemplate">
    <app-custom-notifications></app-custom-notifications>
</div>

<!-- Row: Filter Row -->
<div *ngIf="!showRescheduleTemplate && !showCustomNotificationTemplate"
    class="tile-progress bg-white text-left col-lg-12" style="margin-bottom: 20px;">
    <div class="row">

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
            <label style="display: flex;">Select Account
                <span class="mandatory-symbol">&nbsp;*</span>
            </label>
            <ng-select #filterAccount name="accounts" placeholder="Select account" bindLabel="accountName" bindValue="accountId"
                [items]="accounts" [clearable]="true" [searchable]="true" [(ngModel)]="accountId"
                (change)="getScreeningCentersByAccountID()">
            </ng-select>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" *ngIf="showScreeningCenterDropdown">
            <label style="display: flex;">Select Screening Center
                <span class="mandatory-symbol">&nbsp;*</span>
            </label>
            <div class="controls">
                <ng-multiselect-dropdown [disabled]="accountId == null" [settings]="dropdownSettings"
                    [data]="screeningCenterList" name="screeningCenters" [(ngModel)]="screeningCenterToBind"
                    (onSelect)="onSelectScreeningCenter($event,'ADD')"
                    (onDeSelect)="onSelectScreeningCenter($event,'REMOVE')"
                    (onSelectAll)="onSelectScreeningCenter($event,'ADD_ALL')"
                    (onDeSelectAll)="onSelectScreeningCenter($event,'REMOVE_ALL')">
                </ng-multiselect-dropdown>
            </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" *ngIf="showOperatorDropdown">
            <label style="display: flex;">Select Operator
                <span class="mandatory-symbol">&nbsp;*</span>
            </label>
            <div class="controls">
                <ng-multiselect-dropdown [disabled]="orgIds == null" [settings]="dropdownSettings" [data]="operators"
                    name="operators" [(ngModel)]="operatorToBind" (onSelect)="onSelectOperator($event,'ADD')"
                    (onDeSelect)="onSelectOperator($event,'REMOVE')" (onSelectAll)="onSelectOperator($event,'ADD_ALL')"
                    (onDeSelectAll)="onSelectOperator($event,'REMOVE_ALL')">
                </ng-multiselect-dropdown>
            </div>
        </div>

    </div>

    <div class="row" style="margin-top: 15px;">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
            <label style="display: flex;">Select Date Range
                <span class="mandatory-symbol">&nbsp;*</span>
            </label>
            <ngx-mat-drp #dateRangePicker [options]="calendarOptions" [disabled]="selectedOperatorIds == null"
                (selectedDateRangeChanged)="updateDateRange($event)">
            </ngx-mat-drp>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-8" style="margin-top: 28px; text-align: end;">
            <button type="button" class="btn btn-info btn-raised" (click)="getAppointmentDetails(0, 'start')"
                [disabled]="operatorIds == null || operatorIds.length == 0" style=" width: 220px;">
                <span tooltip="Get appointment details" style="color: #fff; text-align: center;">Get Appointments</span>
            </button>
        </div>
    </div>
</div>
<!-- Row: Filter Row ENDS-->

<div *ngIf="showAppointmentDetails && !showCustomNotificationTemplate">

    <div *ngIf="!showRescheduleTemplate" class="col-sm-2 col-lg-3 col-sm-2 col-xs-2" style="display: flex;">
        <input type="checkbox" style="width: 20px;" (change)="CheckAllOptions()" class="checkbox"
            [(ngModel)]="isChecked" [disabled]="appointments==null || appointments.length==0 || isSelectAll">
        <span style="margin-top: 10px; margin-left: 10px;">Select All (Current page)</span>
    </div>

    <div *ngIf="!showRescheduleTemplate && totalAppointmentsCount > 10" class="col-sm-2 col-lg-3 col-sm-2 col-xs-2" style="display: flex;">
        <input type="checkbox" style="width: 20px;" (change)="CheckAllPagesOptions()" class="checkbox"
            [(ngModel)]="isSelectAll" [disabled]="appointments==null || appointments.length==0">
        <span style="margin-top: 10px; margin-left: 10px;">Select All (All pages)</span>
    </div>

    <div *ngIf="!showRescheduleTemplate" style="text-align:end; margin-bottom:10px">
        <span style="font-weight: bold; padding-top: 10px; float: left;"
            [ngStyle]="{'visibility':cancelAppointmentCount > 0 ? 'visible' : 'hidden'}">{{cancelAppointmentCount}}
            <span *ngIf="cancelAppointmentCount === 1">appointment selected</span>
            <span *ngIf="cancelAppointmentCount > 1">appointments selected</span>
        </span>

        <button type="button" (click)="cancelAppointmentModal(cancelConfirmationContent)"
            class="btn btn-info btn-raised" [disabled]="appointments==null || appointments.length==0 || operatorIds == null || operatorIds.length == 0"
            style="margin-right: 30px; width: 220px;">
            <span tooltip="Click here to cancel the appointment(s)">
                <i class="fa fa-times" style="margin-top:6px;color:#fff;"></i> Cancel Appointment(s)</span>
        </button>
    </div>


    <div *ngIf="!showRescheduleTemplate; then tableTemplate; else rescheduleTemplate;">
    </div>

    <div>

        <ng-template #tableTemplate>
            <div class="content-body padding-top-20 padding-bottom-20">
                <div class="row">
                    <p-table [value]="appointments" [paginator]="appointments!=null && appointments.length>10"
                        [rows]="10" #dt>
                        <ng-template pTemplate="header">
                            <tr style="height:50px;">
                                <th style="text-align: center;width: 6%; padding: 0;">Select
                                </th>
                                <th style="text-align: center;width: 5%;">#
                                </th>
                                <th style="width: 22%;" [pSortableColumn]="'mrn'">MRN
                                    <p-sortIcon [field]="'mrn'"></p-sortIcon>
                                </th>
                                <th style="width: 19%;">Created
                                </th>
                                <th style="width: 19%;">Start Date/Time
                                </th>
                                <th style="width: 19%;">End Date/Time
                                </th>
                                <th style="width: 10%;">Reschedule
                                </th>
                            </tr>
                            <!-- <tr *ngIf="appointments==null || appointments.length==0"
                                style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
                                <td colspan="6">
                                    <div style="padding: 5px;text-align: center;">
                                        No appointments found
                                    </div>
                                </td>
                            </tr> -->
                            <tr *ngIf="appointments?.length > 0" style="font-family:Arial, FontAwesome;text-align: center;">
                                <td class="primeng-table-search">
                                </td>
                                <td class="primeng-table-search">
                                </td>
                                <td class="primeng-table-search">

                                    <input class="primeng-table-search-field search-bar-true" [(ngModel)]="mrnInputText"
                                        placeholder="&#xf002;  Search MRN " pInputText type="text"
                                        (input)="searchByMRN($event.target.value)">
                                </td>
                                <td class="primeng-table-search">
                                </td>
                                <td class="primeng-table-search">
                                </td>
                                <td class="primeng-table-search">
                                </td>
                                <td class="primeng-table-search">
                                </td>
                                <td class="primeng-table-search">
                                </td>
                            </tr>
                            <tr *ngIf="appointments==null || appointments.length==0"
                                style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
                                <td colspan="6">
                                    <div style="padding: 5px;text-align: center;">
                                        No appointments found
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-appointments let-i="rowIndex">
                            <tr class="table-striped" style="height: 50px;">
                                <td style="text-align: -webkit-center;">
                                    <input type="checkbox" style="width: 20px;" (change)="checkedValue(appointments)"
                                        [(ngModel)]="appointments.isChecked" class="checkbox"
                                        [value]="appointments.id" [disabled]="isSelectAll">
                                </td>
                                <td style="text-align: center;">{{ i + 1}}</td>
                                <td>{{appointments.mrn}} </td>
                                <td>{{appointments.created | date: 'dd-MMM-yyyy'}}
                                    {{appointments.created | date: 'shortTime'}}
                                </td>
                                <td>{{appointments.tentativeStartTime | date: 'dd-MMM-yyyy'}}
                                    {{appointments.tentativeStartTime | date: 'shortTime'}}
                                </td>
                                <td>{{appointments.tentativeEndTime | date: 'dd-MMM-yyyy'}}
                                    {{appointments.tentativeEndTime | date: 'shortTime'}}
                                </td>
                                <td style="text-align: center;">
                                    <i class='fa fa-calendar' style='font-size:30px;color:green; cursor: pointer;'
                                        (click)="onRescheduleClick(appointments)"></i>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <tr
                                *ngFor="let eventsList of appointments | paginate: { itemsPerPage: 10, currentPage: page,totalItems: totalAppointmentsCount };">
                            </tr>
                            <td colspan="6" class="text-center">
                                <pagination-controls style="margin-top: 10px;" (pageChange)="onTableDataChange($event)"
                                    *ngIf="appointments!=null && appointments.length>0"></pagination-controls>
                            </td>
                        </ng-template>
                    </p-table>


                </div>
            </div>
        </ng-template>

        <ng-template #rescheduleTemplate>
            <div class="card-header">
                <span>
                    <span>Reschedule Appointment - MRN: {{selectedAppointment.mrn}}</span>
                </span>
                <button class="btn btn-sm btn-warning float-right"
                    style="margin-top: -4px;font-size: 14px;background-color:  rgb(87,200,231);color: #ffffff;height:38px;"
                    (click)="onBackClick()">
                    <span>
                        <i class="fa fa-arrow-left" style="margin-top:6px;color:#fff;"></i> Back</span>
                </button>
            </div>

            <app-reschedule [screeningCenters]="screeningCenterList" [selectedAppointment]="selectedAppointment"
                (onCancel)="onrescheduleCancel($event)" (onReschedule)="onRescheduleCompleted($event)"
                [accountId]="accountId"></app-reschedule>

        </ng-template>

    </div>
</div>

<ng-template #cancelConfirmationContent>
    <div class="modal-header">
        <div style="display:flex; justify-content:space-between; width:100%">
            <h4 style="margin: 0px;">
                Cancel Appointment(s)
                <!-- <i class="fa fa-phone fa-duotone" aria-hidden="true"></i> -->
            </h4>
            <h4 (click)="modalRef.hide()" style="cursor:pointer; margin: 0px;">
                <i class="fa fa-times" aria-hidden="true"></i>
            </h4>
        </div>
    </div>
    <div class="modal-body" style="padding-bottom: 0px;">
        <div class="row">
            <div style="font-weight: bold; padding-top: 10px;">{{cancelAppointmentCount}}
                <span *ngIf="cancelAppointmentCount === 1">appointment selected,</span>
                <span *ngIf="cancelAppointmentCount > 1">appointments selected,</span>
            </div>

            <div style="font-weight: bold; padding-top: 10px;">
                <span *ngIf="cancelAppointmentCount === 1">Are you sure you want to cancel this appointment?</span>
                <span *ngIf="cancelAppointmentCount > 1">Are you sure you want to cancel these appointments?</span>
            </div>
        </div>
    </div>
    <div class="modal-footer" style="justify-content: center !important;">
        <div style="display: flex !important;justify-content: center !important;">
            <div>
                <button class="btn btn-sm btn-warning btn-80"
                    style="background-color:#5d9cec; border:1px solid #5d9cec; color:white; border-radius:0px; width:150px;"
                    (click)="modalRef.hide();cancelAppointment()" id="acceptContinueBtn">Confirm</button>
            </div>
        </div>
    </div>
</ng-template>